import {
    ItemsScope,
    ItemsCommandBar,
    ItemCacheProvider,
    ControlHandlerProvider,
    itemsCommandBarControl,
    IItemCache,
    getItemsScope,
    selectedItemsFacet,
} from '@ms/items-view';
import { observer } from 'mobx-react';
import * as React from 'react';
import { getParameterStore } from '../store/ParametersStore';
import { itemCacheStore, getItemScopeItemKey } from '../store/cache';
import { getCommandBarActions } from '../utils/getCommandBarActions';

@observer
export class FilesViewCommandBar extends React.Component<{}, {}> {
    public render(): JSX.Element {
        return (
            <ItemCacheProvider
                store={itemCacheStore}
                key={`${getParameterStore().mailboxInfo &&
                    getParameterStore().mailboxInfo.mailboxId}-cmdbar`}>
                <ItemsScope itemsScopeItemKey={getItemScopeItemKey()}>
                    <ControlHandlerProvider
                        controlHandlers={{
                            ...itemsCommandBarControl.pack(itemsCommandBarControlHandler),
                        }}>
                        <ItemsCommandBar />
                    </ControlHandlerProvider>
                </ItemsScope>
            </ItemCacheProvider>
        );
    }
}

function itemsCommandBarControlHandler(
    itemCache: IItemCache,
    props: typeof itemsCommandBarControl.inputType
): typeof itemsCommandBarControl.returnType {
    const { itemsScopeItemKey } = getItemsScope(itemCache);

    const selectedItems = itemCache.demandItemFacet(selectedItemsFacet, itemsScopeItemKey);
    const selectedItemKeys = selectedItems && selectedItems.itemKeys;

    const hasSelection = selectedItemKeys && selectedItemKeys.length > 0;

    return {
        commands: getCommandBarActions(hasSelection),
    };
}
